import { TOGGLE_PROFESSION_CATEGORY } from "./../../../constants/ProfessionConstants";

export default function toggleProfessionCategoryAction(term_id: number) {
    return {
        type: TOGGLE_PROFESSION_CATEGORY,
        term_id
    };
}
